import { render } from "./tradeModal.vue?vue&type=template&id=108252b4&scoped=true"
import script from "./tradeModal.vue?vue&type=script&lang=js"
export * from "./tradeModal.vue?vue&type=script&lang=js"

import "./tradeModal.vue?vue&type=style&index=0&id=108252b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108252b4"]])

export default __exports__